import { Button, Chip, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import Modal, { CommonModalProps } from "..";
import { AddItemToBasketRequest } from "../../../Core/Api/Types/add-item-to-basket-request";
import { GetMetadataByTagName } from "../../../Core/Utils/asset-object-utils";
import { produce } from "immer";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import { useTranslation } from "react-i18next";
import { Img } from "react-image";
import { thumbnailService } from "../../../Core/Api/services";
import { ThumbnailSize } from "../../../Core/Api/Thumbnail/thumbnail-api-service";
import { Box } from "@mui/system";

type CloseClbProps = {
    confirm: boolean;
};

export type ModalAddSeasonToBasketElementProps = {
    onClose?: (props: CloseClbProps) => void;
    onConfirm?: (request: AddItemToBasketRequest[]) => void;
    data: DbAssetObjectInfos[];
    request: AddItemToBasketRequest[];
};

export type ModalAddSeasonToBasketProps = CommonModalProps<ModalAddSeasonToBasketElementProps>;

const ModalAddSeasonToBasket = React.forwardRef<any, ModalAddSeasonToBasketProps>((props, ref) => {
    const { closeModal, onClose, onConfirm, data, request, ...modalProps } = props;
    const { t } = useTranslation();
    const reference = React.useRef(undefined);
    const [updatedRequest, setUpdatedRequest] = React.useState<AddItemToBasketRequest[]>(request);

    const handleUpdateEpisodes = (episodes: number[], id: number) => {
        setUpdatedRequest(
            produce((draft) => {
                let item = draft.find((a) => a.objectId === id);
                item!.episodesNbList = episodes;
            })
        );
    };

    const handleToggleEpisode = (episode: number, id: number) => {
        setUpdatedRequest(
            produce((draft) => {
                let item = draft.find((a) => a.objectId === id);
                if (item!.episodesNbList?.includes(episode)) {
                    item!.episodesNbList = item!.episodesNbList?.filter((x) => x !== episode);
                } else {
                    item!.episodesNbList?.push(episode);
                }
            })
        );
    }

    const handleCancelClick = () => {
        onClose && onClose({ confirm: false });
        closeModal();
    };

    const handleConfirmClick = () => {
        onConfirm && onConfirm(updatedRequest);
        closeModal();
    };

    return (
        <Modal
            {...modalProps}
            title={t("modal:title.addSeasonToBasket")}
            reference={reference}
            closeModal={handleCancelClick}
            width={800}
            height={600}
            footer={
                <Stack direction="row" justifyContent="space-between">
                    <Button fullWidth variant="contained" color="primary" onClick={handleConfirmClick} disabled={updatedRequest.some((item => item.episodesNbList!.length === 0))}>
                        {t("common:addToBasket")}
                    </Button>
                </Stack>
            }
        >
            <Stack gap={3}>
                {data.map((object, index) => {

                    const episodes = Array.from(
                        { length: GetMetadataByTagName(object, "serieSeasonEpisodeTotalNumber")?.value },
                        (item, index) => (item = index + 1)
                    )

                    return (
                        <>
                            {index > 0 && <Divider />}
                            <Stack key={index} direction="row" alignItems="flex-start" gap={2}>
                                <Stack
                                    spacing={1.5}
                                    direction="row"
                                    alignItems={"flex-start"}
                                    mt={1}
                                    mb={1}
                                    flex="1 1 30%"
                                >
                                    <Img
                                        src={thumbnailService.GetObjectPosterUrl(object.id, ThumbnailSize.small)}
                                        alt={`poster ${object.id}`}
                                        loading="lazy"
                                        style={{ objectFit: "contain" }}
                                        container={(children) => {
                                            // <img> will be rendered as child of
                                            return (
                                                <Box
                                                    height="100%"
                                                    sx={{ width: 60, height: 80, flexShrink: 0, borderRadius: "4px", clipPath: "content-box" }}
                                                >
                                                    {children}
                                                </Box>
                                            );
                                        }}
                                    />
                                    <Stack>
                                        <Typography variant="subtitle1" color="text.primary">
                                            {object.name}
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary">
                                            #{object.id}
                                        </Typography>
                                    </Stack>
                                </Stack>
                                <Stack flex="1 1 70%" direction="column" flexWrap="wrap" gap={2}>
                                    <Stack direction="row" alignItems="center" gap={2}>
                                        <Typography variant="body1" color="text.primary">{t("modal:body.selectEpisodesToAddToBasket")}</Typography>
                                        <Stack direction="row" gap={1}>
                                            <Button variant="text" onClick={(e) => handleUpdateEpisodes(episodes, object.id)}>All</Button>
                                            <Button variant="text" onClick={(e) => handleUpdateEpisodes([], object.id)}>None</Button>
                                        </Stack>
                                    </Stack>
                                    <Stack direction="row" gap={.5} flexWrap="wrap">
                                        {episodes.map((episode) => {
                                            const selected = updatedRequest.find((x) => x.objectId === object.id)?.episodesNbList?.includes(episode);
                                            return (
                                                <Chip size="medium" color={selected ? "primary" : "default"} label={episode} onClick={() => handleToggleEpisode(episode, object.id)} />
                                            )
                                        })}
                                    </Stack>
                                </Stack>
                            </Stack>
                        </>
                    )
                })}
            </Stack>
        </Modal>
    );
});

export default ModalAddSeasonToBasket;
